import { Component } from '@angular/core';
import { MAPSExportLogEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Export Logs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapsexportlog-form',
    templateUrl: './mapsexportlog.form.component.html'
})
export class MAPSExportLogFormComponent extends BaseFormComponent {
    public record!: MAPSExportLogEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

